module.exports = __webpack_public_path__ + "img/stock3.b0509909.png";